(async () => {
  const storeModuleURL = window.__GLOBAL__.assets.store;
  const module = await import(storeModuleURL);
  const store = module.default;

  class proDealToggle extends HTMLElement {
    constructor() {
      super();
    }

    async connectedCallback() {
      this.discountToggle = this.querySelector("[data-discount-toggle]");
      this.discountToggleText = this.querySelector(
        "[data-discount-toggle-text]"
      );

      this.discountToggleHandler = this.toggleDiscount.bind(this);

      this.discountToggle.addEventListener(
        "change",
        this.discountToggleHandler
      );
      store.events.subscribe('prodeal:discount-enable', this.updateToggleStatus.bind(this))
    }

    async toggleDiscount(evt) {
      evt.preventDefault();
      const enableDiscount = evt.target.checked;

      if (this.loadingDiscount) {
        evt.target.checked = !enableDiscount;
        return;
      }

      this.loadingDiscount = true;
      store.events.publish('cartLoading', true);

      if (enableDiscount) {
        this.discountToggleText.innerText = "ON";
        await fetch(`/discount/${window.customer.proDeal.code}`).then(() => {
          store.events.publish("prodeal:discount-enable", { enabled: true });
          this.loadingDiscount = false;
        });
      } else {
        this.discountToggleText.innerText = "OFF";
        await fetch(`/discount/empty`).then(() => {
          store.events.publish("prodeal:discount-enable", { enabled: false });
          this.loadingDiscount = false;
        });
      }

      const cartPayload = await fetch(`/cart/update.js`, {
        method: 'POST',
        headers:{
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          updates: {},
          sections: document.querySelector('main-cart').id,
          sections_url: window.routes.cart_url
        })
      })
      .then((response) => response.json())
      store.dispatch('cartUpdate', cartPayload, false);
      store.events.publish('cartLoading', false);
    }

    updateToggleStatus({enabled}) {
      if(enabled) {
        this.setToggleOn()
      } else {
        this.setToggleOff();
      }
    }

    setToggleOn() {
      this.discountToggleText.innerText = "ON";
      this.querySelector('input[type="checkbox"]').checked = true;
    }

    setToggleOff() {
      this.discountToggleText.innerText = "OFF";
      this.querySelector('input[type="checkbox"]').checked = false;
    }
  }
  if(!customElements.get("pro-deal-toggle")) {
    customElements.define("pro-deal-toggle", proDealToggle);
  }
})()